const to100 = (x) => Math.round(((x - 1) / 4) * 100);

export function axes(c) {
  const direction = c.vision * 0.5 + c.awareness * 0.5;
  const readiness =
    (c.foundations * 0.22 + c.capability * 0.18 + c.people * 0.20 +
     c.value * 0.20 + c.workforce * 0.12) / 0.92;

  return {
    direction,
    readiness,
    direction100: to100(direction),
    readiness100: to100(readiness)
  };
}
